import { Card, CardBody, Col, Badge } from "reactstrap";
import { FaClock } from "react-icons/fa";

export const Podium = ({ config, Icon }) => {
  return (
    <Col
      key={config.place}
      md="3"
      sm="12"
      className={`order-md-${config.order}`}
    >
      <Card
        className="border-0 shadow-lg text-center overflow-hidden"
        style={{
          borderRadius: "24px",
          height: config.height,
          transition: "0.2s ease",
        }}
      >
        <CardBody className="d-flex flex-column justify-content-center align-items-center p-4">
          <div
            className="d-flex align-items-center justify-content-center mb-3"
            style={{
              width: 70,
              height: 70,
              borderRadius: "50%",
              background: "#f8f9fa",
            }}
          >
            <Icon size={config.iconSize} color={config.color} />
          </div>

          <Badge
            pill
            color={
              config.place === 1
                ? "warning"
                : config.place === 2
                  ? "secondary"
                  : ""
            }
            className="px-3 py-2 mb-3"
            style={{ backgroundColor: config.color }}
          >
            {config.title}
          </Badge>

          <h4 className="fw-bold mb-2 text-center">
            {config.data?.campo || "-"}
          </h4>

          <div className="d-flex align-items-center gap-2 mb-2">
            <FaClock />
            <span className="fw-semibold fs-5">
              {config.data?.hora_promedio || "--:--"}
            </span>
          </div>

          <div
            className="w-100 py-1 px-2"
            style={{
              backgroundColor: "#f8f9fa",
              borderRadius: "16px",
              border: "1px solid #e9ecef",
            }}
          >
            <div
              className="text-muted text-uppercase"
              style={{
                fontSize: "0.75rem",
                letterSpacing: "0.5px",
              }}
            >
              Total capturas
            </div>

            <div
              className="fw-bold"
              style={{
                fontSize: "1.45rem",
                lineHeight: 1.2,
              }}
            >
              {config.data?.total_actividades ?? 0}
            </div>
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};
